const parseNumberFromCurrencyValue = (val) => {
  if (val == null || val === '') return null
  // Keep only digits, decimal point, and negative sign
  const cleaned = String(val).replace(/[^\d.-]/g, '')
  const num = Number(cleaned)
  return isNaN(num) ? null : num
}

export default parseNumberFromCurrencyValue
